export function getCloseIconUrl(color = '#8B4513') {
  const encodedCloseIcon = encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="${color}">
      <path d="M2.5 2.5l11 11m0-11l-11 11" stroke="${color}" stroke-width="2" stroke-linecap="round"/>
    </svg>
  `);
  return `url("data:image/svg+xml,${encodedCloseIcon}")`;
}
